module.exports = __webpack_public_path__ + "img/樊永刚.5e7ee2de.jpg";